const type = {
    2: '图片',
    3: '文本',
    4: '组合'
}

const actionType = {
    0: '什么都不做',
    1: '跳转URL',
    2: '请求API',
}

const buttonActionType = {
    1: '跳转URL',
    2: '请求API',
    3: '关闭弹窗'
}

Object.freeze(type)
Object.freeze(actionType)
Object.freeze(buttonActionType)

export default {
    type,
    actionType,
    buttonActionType
}